import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// ULTIMATE FIX: Force Unregister potentially stale Service Workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister();

    }
  });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
